<template>
  <el-form ref="form" :model="form" class="">
    <el-row :gutter="10">
      <el-col :span="4">
        <el-form-item label="区域" prop="areaId">
          <el-cascader
            v-model="form.areaId"
            placeholder="请选择区域"
            :props="props"
            @change="handleChangeValue"
            clearable
          ></el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item prop="loginTypeQuery" label="登录类型:">
          <el-select
            class="search-select"
            v-model="form.loginTypeQuery"
            placeholder="请选择登录类型"
          >
            <el-option label="全部" :value="null"></el-option>
            <el-option label="微信小程序" :value="0"></el-option>
            <el-option label="APP" :value="1"></el-option>
          </el-select> </el-form-item
      ></el-col>
      <el-col :span="4">
        <el-form-item prop="userType" label="用户类型:">
          <el-select
            class="search-select"
            v-model="form.userType"
            placeholder="请选择用户类型"
          >
            <el-option label="租售平台用户" :value="1"></el-option>
            <el-option label="物业推荐用户" :value="2"></el-option>
            <el-option label="酒店宴会推荐用户" :value="3"></el-option>
          </el-select> </el-form-item
      ></el-col>
      <el-col :span="4">
        <el-form-item prop="name" label="姓名:">
          <el-input
            class="search-input"
            v-model="form.name"
            placeholder="请输入姓名"
            @blur="onBlur"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item prop="invitePersonUserId" label="邀请人:">
          <el-select
            class="select"
            v-model="form.invitePersonUserId"
            filterable
            remote
            placeholder="请输入邀请人"
            :remote-method="searchUser"
            @change="checkItem"
            clearable
            :loading="loading"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item prop="deviceId" label="设备ID:">
          <el-input
            class="search-input"
            v-model="form.deviceId"
            placeholder="请输入设备ID"
            @blur="onBlur"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="4">
        <el-form-item prop="mobile" label="手机号:">
          <el-input
            class="search-input"
            v-model="form.mobile"
            placeholder="请输入手机号"
            @blur="onBlur"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item prop="userId" label="用户ID:">
          <el-input
            class="search-input"
            v-model="form.userId"
            placeholder="请输入用户ID"
            @blur="onBlur"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item prop="openId" label="openID:">
          <el-input
            class="search-input"
            v-model="form.openId"
            placeholder="请输入微信openId"
            @blur="onBlur"
          ></el-input>
        </el-form-item>
      </el-col>

      <!-- <el-col :span="4">
        <el-form-item prop="mobile" label="微信手机号:">
          <el-input
            class="search-input"
            v-model="form.mobile"
            placeholder="请输入微信手机号"
            @blur="onBlur"
          ></el-input>
        </el-form-item>
      </el-col> -->
      <!-- <el-col :span="4">
        <el-form-item prop="nickName" label="微信昵称:">
          <el-input
            class="search-input"
            v-model="form.nickName"
            placeholder="请输入微信昵称"
            @blur="onBlur"
          ></el-input>
        </el-form-item>
      </el-col> -->
      <el-col :span="6">
        <el-form-item prop="searchValue" label="登录时间:">
          <el-date-picker
            class="search-select"
            type="datetimerange"
            v-model="form.time"
            @blur="onBlur"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="登录开始时间"
            end-placeholder="登录结束时间"
            clearable
            placeholder="登录时间"
            :default-time="['00:00:00', '23:59:59']"
          />
        </el-form-item>
      </el-col>

      <el-col :span="4">
        <el-form-item class="btn">
          <el-button @click="onSearch" icon="el-icon-search" size="small"
            >查询</el-button
          >
          <el-button size="small" icon="el-icon-plus" @click="resetForm('form')"
            >清空</el-button
          >
          <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
            >刷新</el-button
          >
          <PermissionsBtn2
            :icon="'el-icon-download'"
            :btnType="'primary'"
            :permissionName="'_Export'"
            :downloadUrl="'/userAdmin/Home/WechatLoginLogDownLoad'"
            :checkList="checkList"
            :form="{
              ...exportForm,
              pageSize: 99999,
              pageIndex: 1,
              isExport: true,
            }"
          ></PermissionsBtn2>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="float: right"> </el-row>
  </el-form>
</template>

<script>
import { encrypt, decrypt } from '@/utils/encryp';
import { getSysLoginApi } from '@/api/log';
import { getAreaListApi } from '@/api/areaApi.js';
import { getToken } from '@/utils/token.js';
import PermissionsBtn2 from '@/components/PermissionsBtn2';
import { getUserModelApi } from '@/api/user.js';

export default {
  components: {
    PermissionsBtn2,
  },
  name: 'UserMoneyBar',
  // 与 layout 组件配合使用 provide / inject组合
  inject: ['reload'], // 注入reload方法
  props: {
    checkList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      SysMenuList: [],
      LoginList: [],
      SysOperationList: [],
      form: {
        loginTypeQuery: '',
        userType: '',
        userId: '',
        openId: '',
        mobile: '',
        // nickName: '',
        name: '',
        invitePersonUserId: '',
        deviceId: '',
        searchValue: '',
        time: [],
        areaId: '',
      },
      options: [],
      exportForm: {
        loginTypeQuery: '',
        userType: '',
        userId: '',
        openId: '',
        mobile: '',
        // nickName: '',
        name: '',
        invitePersonUserId: '',
        deviceId: '',
        searchValue: '',
        time: [],
        areaId: '',
      },
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          const userInfo = JSON.parse(getToken('userInfo'));
          let { areaId, roleType } = userInfo;
          if (level == 0) {
            getAreaListApi({ areaId, roleType }).then((res) => {
              if (res.code === 200) {
                // console.log(res.data, 'lalala');
                const arr = res.data.area.map((item) => {
                  return {
                    value: item.areaId,
                    label: item.areaName,
                    leaf: true,
                    // leaf: !item.houseDtos.length,
                  };
                });
                this.options = arr;
                resolve(arr);
              }
            });
          }
        },
      },
    };
  },
  created() {
    // getSysMenuApi().then((res) => {
    //   let list = [];
    //   for (let i in res.data) {
    //     list.push({ label: res.data[i], value: i });
    //   }
    //   this.SysMenuList = list;
    // });
    getSysLoginApi().then((res) => {
      let list = [];
      for (let i in res.data) {
        list.push({ label: res.data[i], value: i });
      }
      // console.log('获取的登录类型', list);
      this.LoginList = list;
    });
    // getSysOperationApi().then((res) => {
    //   let list = [];
    //   for (let i in res.data) {
    //     list.push({ label: res.data[i], value: i });
    //   }
    //   this.SysOperationList = list;
    // });
  },
  methods: {
    // 搜索邀请人
    async searchUser(val) {
      this.loading = true;
      let res = await getUserModelApi({
        userName: val,
        areaId: this.areaId,
        pageIndex: 1,
        pageSize: 100000,
      });
      this.loading = false;
      this.options = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
    },
    handleUserDecrypt(str, isShowAll) {
      if (!str) return;
      let index1 = str.indexOf('(');
      let index2 = str.indexOf(')');
      let str2 = str.substring(index1 + 1, index2);
      let str1 = str.replace(`(${str2})`, '');
      return `${decrypt(str1)}(${
        isShowAll
          ? decrypt(str2)
          : decrypt(str2).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      })`;
    },
    // 选择下拉选择邀请人
    checkItem(val) {
      this.form.invitePersonUserId = val;
      this.exportForm.invitePersonUserId = val;
    },
    // 获取参数
    getParams() {
      let { mobile, name } = this.form;
      let obj = {
        ...this.form,
        mobile: mobile ? encrypt(mobile) : '',
        name: name ? encrypt(name) : '',
      };
      if (obj.time.length > 1) {
        obj = {
          ...obj,
          sLastLoginTime: this.form.time.length > 1 ? this.form.time[0] : null,
          eLastLoginTime: this.form.time.length > 1 ? this.form.time[1] : null,
        };
      }
      delete obj.time;
      return obj;
    },
    handleChangeValue(arr) {
      // console.log('城市选择：', arr);
      this.form.areaId = arr[0];
      this.exportForm['areaId'] = this.form['areaId'];
    },
    // 搜索
    onSearch() {
      let { mobile, name } = this.form;
      this.$parent.paginObj.pageIndex = 1;
      let obj = {
        ...this.form,
        mobile: mobile ? encrypt(mobile) : '',
        name: name ? encrypt(name) : '',
      };
      if (obj.time.length > 1) {
        obj = {
          ...obj,
          sLastLoginTime: this.form.time.length > 1 ? this.form.time[0] : null,
          eLastLoginTime: this.form.time.length > 1 ? this.form.time[1] : null,
        };
      }
      delete obj.time;
      console.log('搜索参数', obj);
      this.$parent.fetchData(obj);
    },

    // 失去焦点
    onBlur() {
      let { mobile, name } = this.form;

      this.exportForm = {
        // userName: userName ? encrypt(userName) : '',
        // mobile: mobile ? encrypt(mobile) : '',
        ...this.form,
        mobile: mobile ? encrypt(mobile) : '',
        name: name ? encrypt(name) : '',
        sLastLoginTime: this.form.time.length > 1 ? this.form.time[0] : null,
        eLastLoginTime: this.form.time.length > 1 ? this.form.time[1] : null,
      };
      delete this.exportForm.time;
    },

    // 清空表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.form = {
        userId: '',
        openId: '',
        mobile: '',
        name: '',
        time: [],
      };
      this.exportForm = {
        userId: '',
        openId: '',
        mobile: '',
        name: '',
        time: [],
      };
    },

    // 刷新当前页面
    onRefresh() {
      this.reload();
    },
  },
};
</script>

<style lang="less" scoped>
.form_flex {
  display: flex;
}

.search-input {
  margin: 0 10px;
  width: 170px;
}

.search-select1 {
  width: 120px;
}
.select {
  margin-right: 10px;
}

button {
  height: 40px;
  margin-left: 10px;
}

/deep/ .el-form-item__content {
  display: flex;
}
</style>
